import React from 'react';
import Form from 'react-bootstrap/Form';
import { LinkButton } from '../common';
import './styles/commonPage.scss';

const SignInPage = () => {
  return (
    <div className="occu-form">
      <h5>
        Did you use your Orange County's Credit Union Digital Banking login information to start your home loan
        application?
      </h5>
      <Form>
        <LinkButton href="/olb/forgot-credentials">Yes</LinkButton>
        <LinkButton href="/mortgage/forgot-credentials">No</LinkButton>
      </Form>
    </div>
  );
};

export default SignInPage;
